<div class="admin-container">
  <div class="sidenav">
    <mat-nav-list>
      <a mat-list-item> Scholarship </a>
    </mat-nav-list>
  </div>
  <div class="content">
    <app-scholarship-dashboard></app-scholarship-dashboard>
  </div>
</div>
